import styled from 'styled-components';
import {device} from '../../../../../../utils/device';

export const LoginMainWrap = styled.div(
  props => `
        width:47.5rem;
        height: 45.5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-color: #ffffff;
        border-radius: 0.8rem;
        box-shadow: 0 1px 16px 0 rgba(0, 0, 0, 0.6);

        @media(max-width:1023px){
            width:94%;
            margin:0 auto;
        }
    `,
);

export const LoginWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        padding: 3rem;
        flex-direction: column;
        padding-bottom: 12px;
        @media(max-width:1023px){
            padding:1.5rem;
        }
    `,
);

export const LoginHeadText = styled.h2(
  props => `
        font-size: 2.8rem;
        color: #000000;
        font-weight: 900;
    `,
);

export const LoginSubText = styled.p(
  props => `
        font-size: 1.5rem;
        color: #000000;
        padding-top:.5rem;
    `,
);

export const LoginInputWrap = styled.div(
  props => `
        display: flex;
        margin-top:1.5rem;
        width:100%;
        border-width:1px;
        border-style: solid;
        border-radius: 0.2rem;
        padding: 1rem 1.2rem;
        align-items: center;
        border-color: ${props.hasError ? props.theme.colors.red.base : ' #d0d0d0'};
        img{
          width: 22px;
        }
    `,
);

export const LoginPrefix = styled.p(
  props => `
        font-size: 1.6rem;
        color: #000000;
        font-weight: bold;
        padding-left: 0.5rem;
    `,
);

export const TextInput = styled.input(
  props => `
    width:90%;
    border: none;
    background-color: ${props.theme.colors.white.base};
    border-radius: 0;
    font-size: ${props.theme.font.large.font16};
    padding-left: ${props.theme.spacing.large.l15};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    position: relative;
    cursor: pointer;
    ::placeholder {
      lin-height: ${props.theme.font.lineHeight.large};
      font-size: ${props.theme.font.large.font16};
      color: ${props.theme.colors.grey.lightc5};
      overflow: visible;
    }
    @media only screen and (min-width: 320px) and (max-width: 991px) {
      font-size: ${props.theme.font.large.font14};
    }
    opacity: ${props.disabled ? '0.4' : '1'};
    pointer-events: ${props.disabled ? 'none' : ''};
    border-color: ${props.hasError ? props.theme.colors.red.base : ''};
    text-transform: ${props.isPAN ? props.theme.font.textTransform.upper : ''};
    outline: none;
`,
);

export const LoginButtonWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        margin-top: 2rem;
    `,
);

export const LoginTermsWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
);

export const LoginTermsText = styled.p(
  props => `
        font-size: 12px;
        color: #666666;

        @media(max-width:1023px){
            font-size: 1.2rem;
        }
    `,
);

export const OfferWrap = styled.div(
  props => `
        display: flex;
        background-color: #ffefdc;
        padding: 2.5rem 3rem;
        border-radius: 0 0 4px 4px;
        position:relative;

        @media(max-width:1023px){
            padding:1.5rem;
        }
    `,
);

export const OfferTextWrap = styled.div(
  props => `
        display: flex;
        flex-direction: column;
    `,
);

export const OfferHeadText = styled.p(
  props => `
        font-size:1.4rem;
        color: #000000;
        span{
          font-weight: bold;
        }
    `,
);

export const OfferSubText = styled.p(
  props => `
        font-size:1.2rem;
        color: #000000;
        line-height:1.2;
        padding-top: 0.5rem;
    `,
);

export const TopBorder = styled.div(
  props => `
        position: absolute;
        top:0;
        left:0;
        background-image: linear-gradient(to right, rgba(174, 95, 20, 0) 0%, #c69b1d 49%, rgba(214, 193, 35, 0) 100%);
        width:100%;
        height:2px;
    `,
);

export const SpecialTag = styled.p(
  props => `
        width: 9rem;
        height: 1.6rem;
        display: flex;
        position:absolute;
        align-items: center;
        justify-content: center;
        background-image: linear-gradient(269deg, #c9c106 0%, #c34141 99%);
        border-radius: 2.5rem;
        top:-0.8rem;
        left:3rem;
        font-weight: bold;
        font-size: 1rem;
        color: #ffffff;
        text-transform: uppercase;
    `,
);
export const Para = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 12px;
  width: 100%;
  margin-top: 0px;
  span {
    font-weight: 700;
  }
`;
export const TncText = styled.span`
  font-size: 10px;
  font-weight: 600;
  margin-top: -5px;
  color: #000;
  @media ${device.mobileS} {
    font-weight: 400;
  }
`;
